import React, { useState } from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import CountrySelect from "../utils/countrySelect";
import { getCountryCallingCode } from "react-phone-number-input";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const LINE = "#E4E9EF";
const PRIMARY = "#0B5C8A";
const btn = {
  height: 44,
  borderRadius: "10px !important",
  background: `${PRIMARY} !important`,
  color: "#FFFFFF !important",
  border: "0 !important",
  fontFamily: FONT,
  fontSize: 14,
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { background: "#084767 !important" },
};

const AcceptInvite = () => {
  const [data, setData] = useState({
    username: "",
  });
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [inviteModal, setInviteModal] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();
  const [phoneCountry, setPhoneCountry] = useState("IN");

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });
  };

  const validateFields = () => {
    const errors = {};
    // if (!data.username.trim()) {
    //   errors.username = "Username is required.";
    // } else if (!/^[6-9]\d{9}$/.test(data.username)) {
    //   errors.username = "Invalid mobile number (must be 10 digits)";
    // }
    return errors;
  };

  const checkInvitation = async () => {
    try {
      console.log(data)
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/user?username=${data.username.replace(/\D/g, "")}`,
      );
      if (res.data.isInvited) {
        setInviteModal(true);
      }
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to reset password.");
    }
  };

  const handleAcceptInvite = async () => {
    try {
      const res = await axios.get(
        // `${process.env.REACT_APP_BACKEND_URL}/membership?username=${getCountryCallingCode(phoneCountry)}${data.username.replace(/\D/g, "")}&token=${token}`,
        `${process.env.REACT_APP_BACKEND_URL}/membership?username=${data.username.replace(/\D/g, "")}&token=${token}`,
      );
      if (res.data.status === "INVITED") {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/accept-invite`,
          {
            // username: `${getCountryCallingCode(phoneCountry)}${data.username.replace(/\D/g, "")}`,
            username: data.username.replace(/\D/g, ""),
            countryCode: getCountryCallingCode(phoneCountry),
            orgId: token,
          },
        );
      }
      setInviteModal(false);
      navigate("/");
    } catch (error) {
      setError(
        error.response?.data?.Exception || "Failed to accpet invitaion.",
      );
    }
  };

  return (
    <Box
      className="border-container"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: "#F4F7FA",
        fontFamily: FONT,
        color: INK,
      }}
    >
      <form
        style={{
          width: "100%",
          maxWidth: 420,
          boxSizing: "border-box",
          background: "#FFFFFF",
          border: `1px solid ${LINE}`,
          borderRadius: 16,
          padding: "28px 24px 24px",
        }}
      >
        <Typography
          variant="h4"
          textAlign={"center"}
          mb={0.75}
          sx={{ fontFamily: FONT, fontSize: 26, fontWeight: 800, letterSpacing: "-0.028em" }}
        >
          Invitation
        </Typography>
        <Typography textAlign={"center"} mb={3} sx={{ fontFamily: FONT, fontSize: 14, color: "#4A5A6E" }}>
          Enter your registered mobile number
        </Typography>
        <div
          className={`phone-container`}
          style={{
            display: "flex",
            alignItems: "center",
            height: 44,
            margin: 0,
            border: "1px solid #D5DEE7",
            borderRadius: 10,
            overflow: "hidden",
            background: "#FFFFFF",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", height: "100%", padding: "0 4px", background: "#F7F9FC", borderRight: `1px solid ${LINE}` }}>
            <CountrySelect
              value={phoneCountry}
              onChange={(c) => setPhoneCountry(c)}
            />
          </div>
          <input
            type="tel"
            name="username"
            id="username"
            onChange={(e) =>
              setData((prev) => ({ ...prev, username: e.target.value }))
            }
            placeholder="Enter phone number"
            style={{ flex: 1, minWidth: 0, height: "100%", margin: 0, padding: "0 12px", border: 0, outline: "none", background: "transparent", fontFamily: MONO, fontSize: 14, color: INK }}
          />
        </div>
        {fieldErrors.username && (
          <Typography sx={{ color: "#C42B24", fontSize: "12px", mt: 0.75 }}>
            {fieldErrors.username}
          </Typography>
        )}

        {error && (
          <Typography sx={{ mt: 1.5, p: "8px 12px", fontSize: 13, color: "#A6342A", background: "#FBEDEB", border: "1px solid #F2CFCA", borderRadius: "10px" }}>
            {error}
          </Typography>
        )}
        <Box className="btn-container" sx={{ mt: 2.5 }}>
          <Button className="btn-contained" fullWidth onClick={checkInvitation} sx={btn}>
            Submit
          </Button>
        </Box>
      </form>

      <Modal
        open={inviteModal}
        onClose={() => setInviteModal(false)}
        slotProps={{ backdrop: { sx: { background: "rgba(15,27,42,0.46)" } } }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 380,
            maxWidth: "92vw",
            bgcolor: "#FFFFFF",
            border: 0,
            boxShadow: "0 32px 64px -20px rgba(15,27,42,0.5)",
            p: 3,
            borderRadius: "18px",
            outline: "none",
          }}
        >
          <Typography
            variant="h6"
            textAlign="center"
            mb={1}
            sx={{ fontFamily: FONT, fontSize: 16.5, fontWeight: 800, letterSpacing: "-0.015em", lineHeight: 1.4, color: INK }}
          >
            By accepting this invitation, you will be added in the invited organization.
          </Typography>
          <Button
            className="btn-contained"
            fullWidth
            sx={{ mt: 2, ...btn }}
            onClick={handleAcceptInvite}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default AcceptInvite;
